export default __webpack_public_path__ + "static/media/022-picture-1.4b64a3d8.png";